/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesGroupsApplicationGroupingsGroupingsRowResponse { 
    playerId?: number;
    firstName?: string;
    lastName?: string;
    shortName?: string;
    country?: string;
    hometown?: string;
    r1GrpNum?: number;
    r1StartTee?: number;
    r1StartTime?: string;
    r1SlotNum?: number;
    r1Course?: string;
    r2GrpNum?: number;
    r2StartTee?: number;
    r2StartTime?: string;
    r2SlotNum?: number;
    r2Course?: string;
    r3GrpNum?: number;
    r3StartTee?: number;
    r3StartTime?: string;
    r3SlotNum?: number;
    r3Course?: string;
    r4GrpNum?: number;
    r4StartTee?: number;
    r4StartTime?: string;
    r4SlotNum?: number;
    r4Course?: string;
}